<script>
/**
 * Descripción: Pantalla OrganizationByInstanceFilter Filtro
 *
 * @displayName OrganizationByInstanceFilterViewComponent
 */

const BaseServerDataTable = () =>
  import('@/components/core/grids/BaseServerDataTable.vue');

import BaseLocalHelper from '@/helpers/BaseLocalHelper.js';
import BaseArrayHelper from '@/helpers/BaseArrayHelper.js';
import httpService from '@/services/httpService.js';

export default {
  name: 'OrganizationByInstanceFilterViewComponent',

  components: {
    BaseServerDataTable
  },

  props: {
    /**
     * Enviar información adicional al servidor
     */
    extraParams: {
      type: Object,
      default: undefined
    }
  },

  data() {
    return {
      loading: false,
      editedIndex: -1,
      editStructure: {
        instanceId: this.extraParams.instanceId,
        organizationId: 0,
        locationId: null,
        nodoOrganizacionId: null,
        organizationName: null
      },

      structure: {
        instanceId: this.extraParams.instanceId,
        organizationId: 0,
        locationId: null,
        nodoOrganizacionId: null,
        organizationName: null
      }
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? BaseLocalHelper.$_LabelBtnNew
        : BaseLocalHelper.$_LabelBtnEdit;
    },
    /**
     * Configuracion BaseServerDataTable
     */
    setting() {
      return {
        controller: 'OrganizationByInstance',
        method: 'Filter',
        columns: [
          {
            text: 'Organización ID',
            align: 'start',
            value: 'organizationId',
            show: true
          },
          {
            text: 'Locación',
            align: 'start',
            value: 'locationName',
            show: true
          },
          {
            text: 'Nodo Organización ID',
            align: 'start',
            value: 'nodoOrganizacionId',
            show: false
          },
          {
            text: 'Nodo Organización',
            align: 'start',
            value: 'organizationName',
            show: true
          }
        ],
        key: 'identifier',
        singleSelect: false,
        dbClick: 'Complete'
      };
    }
  },

  methods: {
    /**
     * Crear Nuevo Usuario
     */
    $_new() {
      this.$refs._new.$_openModal();
    },

    /**
     * Eliminar Objecto
     */
    $_delete(params) {
      httpService
        .post('OrganizationByInstance/Delete', params)
        .then(response => {
          if (response != undefined) {
            //Logica JS luego de la acción exitosa!!!
            this.$refs.OrganizationByInstanceFilter.$_ParamsToAPI();
          }
        });
    },

    /**
     * Cerrar pantalla emergente
     */
    $_close() {
      this.$refs._new.$_openModal();
      this.$nextTick(() => {
        this.editStructure = BaseArrayHelper.SetObject({}, this.structure);
        this.editedIndex = -1;
      });
    },

    /**
     * Setear objecto del array
     */
    $_edit(params) {
      this.editedIndex = params.index;
      this.editStructure = BaseArrayHelper.SetObject({}, params.selected);
      this.$refs._new.$_openModal();
    },

    /**
     * Guardar o editar Objecto
     */
    $_save() {
      this.loading = true;
      let object = BaseArrayHelper.SetObject({}, this.editStructure);
      object.instanceId = parseInt(object.instanceId);
      object.nodoOrganizacionId =
        object.nodoOrganizacionId != null
          ? parseInt(object.nodoOrganizacionId)
          : null;
      httpService
        .post('OrganizationByInstance/SaveObject', object)
        .then(response => {
          if (response != undefined) {
            this.$refs.OrganizationByInstanceFilter.$_ParamsToAPI();
            this.$_close();
          }
          this.loading = false;
        });
    }
  }
};
</script>

<template>
  <div>
    <!-- @BaseDialog -->
    <BaseDialog ref="_new" width="850" :persistent="true" :tittle="formTitle">
      <div slot="Content">
        <!-- @BaseForm -->
        <BaseForm :method="$_save" :cancel="$_close">
          <div slot="body">
            <!-- @ Use Loanding... -->
            <BaseSkeletonLoader v-if="loading" type="article, actions" />
            <v-row v-else>
              <v-col cols="4">
                <BaseSelect
                  v-model="editStructure.locationId"
                  label="Locación"
                  endpoint="/Location/GridWithList"
                  itemText="locationName"
                  itemValue="locationId"
                  :validate="['text']"
                />
              </v-col>
              <v-col cols="4">
                <!-- @BaseInput -->
                <BaseInput
                  label="Nodo de Organización"
                  v-model="editStructure.nodoOrganizacionId"
                  type="Number"
                />
              </v-col>
              <v-col cols="4">
                <!-- @BaseInput -->
                <BaseInput
                  label="Nombre de la Organización"
                  v-model="editStructure.organizationName"
                />
              </v-col>
            </v-row>
          </div>
        </BaseForm>
      </div>
    </BaseDialog>
    <!-- @BaseServerDataTable -->
    <BaseServerDataTable
      ref="OrganizationByInstanceFilter"
      :extraParams="extraParams"
      :setting="setting"
      :fnNew="$_new"
      :fnEdit="$_edit"
      :fnDelete="$_delete"
    />
  </div>
</template>
